import script from "./join-news-letter-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./join-news-letter-modal.vue?vue&type=script&setup=true&lang=js"

import "./join-news-letter-modal.vue?vue&type=style&index=0&id=5ac96d4a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ac96d4a"]])

export default __exports__